export enum StoreBannersTestIds {
  CAROUSEL = 'store-home-banners',
  SLIDE_PREFIX = 'store-home-banners-slide-',
  DOT_PREFIX = 'store-home-banners-dot-',
}
